module.exports = __webpack_public_path__ + "static/media/diagram-emotional-distress-source.cf03664f.svg";